import { render, staticRenderFns } from "./AgentProductApproval.vue?vue&type=template&id=12fc5eb2&scoped=true"
import script from "./AgentProductApproval.vue?vue&type=script&lang=js"
export * from "./AgentProductApproval.vue?vue&type=script&lang=js"
import style0 from "./AgentProductApproval.vue?vue&type=style&index=0&id=12fc5eb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc5eb2",
  null
  
)

export default component.exports